import { Alert } from 'react-native';
import { checkGmailConnection } from '@/services/gmailSync';
import { clearInboxOauthPending, setInboxOauthSuccess } from '@/utils/inboxOauth';

function isCancellation(msg: string | null): boolean {
  if (!msg) return false;
  return /access_denied|cancel|dismiss/i.test(msg);
}

/**
 * Persist inbox OAuth outcome after redirect from Cloud Functions → tripvio://…-callback
 * (shared by Expo Router routes and optional deep-link helpers).
 */
export async function applyInboxOAuthRedirectResult(
  provider: 'gmail' | 'outlook',
  success: boolean,
  errorMsg: string | null,
): Promise<void> {
  if (success) {
    await clearInboxOauthPending().catch(() => {});
    await setInboxOauthSuccess(provider);
    if (provider === 'gmail') {
      try {
        await checkGmailConnection();
      } catch {
        // best-effort parity with RootLayout inbox handler
      }
    }
    return;
  }
  await clearInboxOauthPending().catch(() => {});
  if (errorMsg && !isCancellation(errorMsg)) {
    Alert.alert(
      provider === 'gmail' ? 'Gmail Connection Failed' : 'Outlook Connection Failed',
      `Failed to connect ${provider === 'gmail' ? 'Gmail' : 'Outlook'}: ${errorMsg}`,
    );
  }
}

export function coerceQueryString(v: string | string[] | undefined): string | undefined {
  if (v === undefined) return undefined;
  const s = Array.isArray(v) ? v[0] : v;
  const t = String(s ?? '').trim();
  return t.length ? t : undefined;
}
